<template>
  <div class="mb-3 d-flex flex-wrap justify-content-center gap-1">
    <!-- USED https://heroicons.dev/ for icons -->
    <button @click="$emit('new')" :disabled="!canCreate" class="btn custom-btn" style="min-width: 125px">
      <svg style="width: 45px; height: 45px;" data-slot="icon" fill="none" stroke-width="1.5" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m3.75 9v6m3-3H9m1.5-12H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"></path>
      </svg>
      <div>
        {{ $t('ribbon.new') }}
      </div>
    </button>
    <button @click="$emit('edit')" :disabled="!canEdit || !isInvoiceSelected" class="btn custom-btn" style="min-width: 125px">
      <svg style="width: 45px; height: 45px;" data-slot="icon" fill="none" stroke-width="1.5" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"></path>
      </svg>
      <div>
        {{ $t('ribbon.edit') }}
      </div>
    </button>

    <button data-testid="invoice-copy-button" @click="$emit('copy')" :disabled="!canCopy || !isInvoiceSelected" class="btn custom-btn" style="min-width: 125px">
      <svg style="width: 45px; height: 45px;" fill="none" stroke-width="1.5" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <rect x="8" y="8" width="12" height="13" rx="2" />
        <path d="M16 8V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h3" />
      </svg>
      <div>Duplizieren</div>
    </button>

    <button @click="$emit('delete')" :disabled="!canDelete || !isInvoiceSelected" class="btn custom-btn" style="min-width: 125px">
      <svg style="width: 45px; height: 45px;" data-slot="icon" fill="none" stroke-width="1.5" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m6.75 12H9m1.5-12H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"></path>
      </svg>
      <div>
        {{ $t('ribbon.delete') }}
      </div>
    </button>

    <button
      data-testid="invoice-download-button"
      @click="$emit('download')"
      :disabled="!canDownload || !isInvoiceSelected || !isZugferdGenerated"
      class="btn custom-btn"
      style="min-width: 125px"
    >
      <svg style="width: 45px; height: 45px;" data-slot="icon" fill="none" stroke-width="1.5" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m.75 12 3 3m0 0 3-3m-3 3v-6m-1.5-9H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"></path>
      </svg>
      <div>
        {{ $t('ribbon.download') }}
      </div>
    </button>

    <div class="position-relative" ref="exportMenuRoot">
      <button
          data-testid="invoice-export-button"
          @click="toggleExportMenu"
          :disabled="!canExport || !isInvoiceSelected"
          class="btn custom-btn"
          style="min-width: 125px"
          :aria-expanded="isExportMenuOpen ? 'true' : 'false'"
          aria-haspopup="menu"
      >
        <svg style="width: 45px; height: 45px;" data-slot="icon" fill="none" stroke-width="1.5" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" d="M16.5 6.75h-9A2.25 2.25 0 0 0 5.25 9v9A2.25 2.25 0 0 0 7.5 20.25h9A2.25 2.25 0 0 0 18.75 18V9A2.25 2.25 0 0 0 16.5 6.75Zm-9-3h9A2.25 2.25 0 0 1 18.75 6v.75h-13.5V6A2.25 2.25 0 0 1 7.5 3.75Zm2.25 7.5h4.5m-4.5 3h3" />
        </svg>
        <div>
          Export
        </div>
      </button>
      <div
          v-if="isExportMenuOpen"
          data-testid="invoice-export-menu"
          class="dropdown-menu show mt-1 w-100"
          role="menu"
      >
        <button
            v-for="option in exportOptions"
            :key="option.id"
            :data-testid="`invoice-export-option-${option.id}`"
            class="dropdown-item"
            type="button"
            role="menuitem"
            :disabled="option.disabled"
            @click="selectExportOption(option)"
        >
          {{ option.label }}
        </button>
      </div>
    </div>

    <button
      data-testid="invoice-import-button"
      @click="$emit('import')"
      :disabled="!canImport || !isInvoiceSelected"
      class="btn custom-btn"
      style="min-width: 125px"
    >
      <svg style="width: 45px; height: 45px;" data-slot="icon" fill="none" stroke-width="1.5" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 16.5V3m0 0 4.5 4.5M12 3 7.5 7.5M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5" />
      </svg>
      <div>
        {{ $t('ribbon.import') }}
      </div>
    </button>

    <button
      data-testid="invoice-view-button"
      @click="$emit('view')"
      :disabled="!canView || !isInvoiceSelected || !isZugferdGenerated"
      class="btn custom-btn"
      style="min-width: 125px"
    >
      <svg style="width: 45px; height: 45px;" data-slot="icon" fill="none" stroke-width="1.5" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m5.231 13.481L15 17.25m-4.5-15H5.625c-.621 0-1.125.504-1.125 1.125v16.5c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Zm3.75 11.625a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z"></path>
      </svg>
      <div>
        {{ $t('ribbon.view') }}
      </div>
    </button>

    <button
      data-testid="invoice-validate-button"
      @click="$emit('validate')"
      :disabled="!canValidate || !isInvoiceSelected || !isZugferdGenerated"
      class="btn custom-btn"
      style="min-width: 125px"
    >
      <svg style="width: 45px; height: 45px;" data-slot="icon" fill="none" stroke-width="1.5" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" d="M10.125 2.25h-4.5c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125v-9M10.125 2.25h.375a9 9 0 0 1 9 9v.375M10.125 2.25A3.375 3.375 0 0 1 13.5 5.625v1.5c0 .621.504 1.125 1.125 1.125h1.5a3.375 3.375 0 0 1 3.375 3.375M9 15l2.25 2.25L15 12"></path>
      </svg>
      <div>
        {{ $t('ribbon.validate') }}
      </div>
    </button>

    <button @click="$emit('refresh')" :disabled="!canRefresh" class="btn custom-btn" style="min-width: 125px">
      <svg style="width: 45px; height: 45px;" data-slot="icon" fill="none" stroke-width="1.5" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"></path>
      </svg>
      <div>
        {{ $t('ribbon.refresh') }}
      </div>
    </button>

  </div>
</template>

<script>
export default {
  name: "InvoiceRibbon",
  props: {
    isInvoiceSelected: Boolean,
    isZugferdGenerated: {
      type: Boolean,
      default: false,
    },
    exportOptions: {
      type: Array,
      default: () => [{ id: "openoffice", label: "OpenOffice", disabled: false }],
    },
    canCreate: {
      type: Boolean,
      default: true,
    },
    canCopy: {
      type: Boolean,
      default: false,
    },
    canEdit: {
      type: Boolean,
      default: true,
    },
    canDelete: {
      type: Boolean,
      default: true,
    },
    canDownload: {
      type: Boolean,
      default: true,
    },
    canExport: {
      type: Boolean,
      default: true,
    },
    canImport: {
      type: Boolean,
      default: true,
    },
    canView: {
      type: Boolean,
      default: true,
    },
    canValidate: {
      type: Boolean,
      default: true,
    },
    canRefresh: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isExportMenuOpen: false,
    };
  },
  methods: {
    toggleExportMenu() {
      if (!this.canExport || !this.isInvoiceSelected) {
        return;
      }

      this.isExportMenuOpen = !this.isExportMenuOpen;
    },
    selectExportOption(option) {
      if (option?.disabled) {
        return;
      }

      this.$emit("export", option.id);
      this.isExportMenuOpen = false;
    },
    handleDocumentClick(event) {
      if (!this.isExportMenuOpen) {
        return;
      }

      const menuRoot = this.$refs.exportMenuRoot;
      if (menuRoot && !menuRoot.contains(event.target)) {
        this.isExportMenuOpen = false;
      }
    },
  },
  mounted() {
    document.addEventListener("click", this.handleDocumentClick);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleDocumentClick);
  },
};
</script>

<style>

</style>
